import { Linkedin, Twitter, Share2 } from "lucide-react";

export default function SocialShareButtons({ url, title }) {
  const shareUrl = encodeURIComponent(url);
  const shareTitle = encodeURIComponent(title);

  const links = [
    {
      label: "LinkedIn",
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`,
      Icon: Linkedin,
    },
    {
      label: "Twitter",
      href: `https://twitter.com/intent/tweet?text=${shareTitle}&url=${shareUrl}`,
      Icon: Twitter,
    },
  ];

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <span className="font-mono text-xs uppercase tracking-widest text-steel flex items-center gap-1.5">
        <Share2 className="w-3.5 h-3.5" /> Share
      </span>
      <div className="flex items-center gap-2">
        {links.map(({ label, href, Icon }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Share on ${label}`}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-border rounded-md text-xs text-steel hover:text-cobalt hover:border-cobalt transition-colors"
          >
            <Icon className="w-4 h-4" />
            {label}
          </a>
        ))}
      </div>
    </div>
  );
}